import { LabelCountProvider } from 'contexts/LabelCountContext'
import LuxPlusMonthLandingPageBenefits from './LuxPlusMonthLandingPageBenefits'
import LuxPlusMonthCruisesOfferCarousel from './offerCarousels/LuxPlusMonthCruisesOfferCarousel'
import LuxPlusMonthEarlyAccessOfferCarousel from './offerCarousels/LuxPlusMonthEarlyAccessOfferCarousel'
import LuxPlusMonthExperiencesOfferCarousel from './offerCarousels/LuxPlusMonthExperiencesOfferCarousel'
import LuxPlusMonthHiddenOfferCarousel from './offerCarousels/LuxPlusMonthHiddenOfferCarousel'
import LuxPlusMonthHotelsOfferCarousel from './offerCarousels/LuxPlusMonthHotelsOfferCarousel'
import LuxPlusMonthToursOfferCarousel from './offerCarousels/LuxPlusMonthToursOfferCarousel'

export const LUX_PLUS_MONTH_LANDING_PAGE_CAROUSELS_SECTION_ID = 'lux-plus-month-carousels'
const ANALYTICS_PAGE = 'LUX-PLUS-MONTH-LANDING-PAGE'

function LuxPlusMonthLandingPageCarousels() {
  return <div id={LUX_PLUS_MONTH_LANDING_PAGE_CAROUSELS_SECTION_ID}>
    <LabelCountProvider maxLabels={2}>
      <LuxPlusMonthHotelsOfferCarousel analyticsPage={ANALYTICS_PAGE} />
      <LuxPlusMonthHiddenOfferCarousel analyticsPage={ANALYTICS_PAGE} />
      <LuxPlusMonthLandingPageBenefits />
      <LuxPlusMonthEarlyAccessOfferCarousel analyticsPage={ANALYTICS_PAGE} />
      <LuxPlusMonthExperiencesOfferCarousel analyticsPage={ANALYTICS_PAGE} />
      <LuxPlusMonthToursOfferCarousel analyticsPage={ANALYTICS_PAGE} />
      <LuxPlusMonthCruisesOfferCarousel analyticsPage={ANALYTICS_PAGE} />
    </LabelCountProvider>
  </div>
}

export default LuxPlusMonthLandingPageCarousels
